module.exports = __webpack_public_path__ + "static/img/good4.2f87a13.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/good4.jpg
// module id = 6B6F
// module chunks = 30